import React from 'react'
import MyTable from '../../UI/table/MyTable'
import { TableCell } from '@mui/material'
import MyTableNotFound from '../../UI/table/MyTableNotFound'
import SupplyBillItemsAllItem from './SupplyBillItemsAllItem'

const SupplyBillItemsAllTable = ({ supplyBillItems, count, offset, setOffset, limit, setLimit, loading }) => {
  return (
    <MyTable
        head={
            <>
                <TableCell align="center">ID</TableCell>
                <TableCell align="center">Заявка №</TableCell>
                <TableCell align="center">Рахунок №</TableCell>
                <TableCell align="center">Назва</TableCell>
                <TableCell align="center">Контракт / проект</TableCell>
                <TableCell align="center">Тип закупівлі</TableCell>
                <TableCell align="center">Кількість</TableCell>
                <TableCell align="center">Вартість</TableCell>
                <TableCell align="center">Погодження</TableCell>
                <TableCell align="center">Дії</TableCell>
            </>
        }
        body={
            supplyBillItems && supplyBillItems.length > 0 ?
                supplyBillItems.map(supplyBillItem => 
                    <SupplyBillItemsAllItem
                        key={supplyBillItem.id}
                        supplyBillItem={supplyBillItem} 
                    />
                )
            : 
                <MyTableNotFound
                    text='Позицій не знайдено' 
                    // columns={6}
                />
        }
        name='позицій'
        count={count}
        limit={limit}
        setLimit={setLimit}
        offset={offset}
        setOffset={setOffset}
        loading={loading}
    />
  )
}

export default SupplyBillItemsAllTable